import { FC, useMemo, useState } from "react"

import LoanProgramCard from "../card"
import LoanProgramCardSkeleton from "../../skeletons/rate-card"
import If from "../../if"
import { SearchBar } from "../../table/toolbar"
import { PricingSets } from "../../../../types"

interface LoanProgramsListProps {
  isLoading: boolean
  pricingSets: PricingSets
  defaultPricingSetId: string
}

const LoanProgramsList: FC<LoanProgramsListProps> = ({
  isLoading,
  pricingSets,
  defaultPricingSetId
}) => {
  const [filter, setFilter] = useState<string>("")

  // Sort pricing sets
  const sortedPricingSets = useMemo(
    () =>
      [...pricingSets].filter(
        item =>
          item.name?.toLowerCase().includes((filter ?? "").toLowerCase()) ||
          item.id
            .toString()
            .toLowerCase()
            .includes((filter ?? "").toLowerCase())
      ),
    [pricingSets, filter]
  )

  const handleSearch = (value: string | number): void => {
    setFilter(value.toString())
  }

  return (
    <div className="bg-white h-full">
      <div className="px-6 flex items-center justify-between">
        <SearchBar
          className="py-4 lg:flex w-full"
          globalFilter={filter}
          onSearch={handleSearch}
          searchPlaceholder="Search loan programs.."
        />
      </div>
      <div className="px-6 pt-4 pb-6">
        <If
          condition={isLoading}
          then={<LoanProgramCardSkeleton />}
          else={
            <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {!!sortedPricingSets?.length ? (
                sortedPricingSets.map(pricingSet => (
                  <LoanProgramCard
                    key={`pricing-set-${pricingSet.id}`}
                    id={pricingSet.id}
                    isDefault={pricingSet.id === defaultPricingSetId}
                  />
                ))
              ) : (
                <div>No loan programs found.</div>
              )}
            </ul>
          }
        />
      </div>
    </div>
  )
}

export default LoanProgramsList
